import { render, staticRenderFns } from "./weekPicker.vue?vue&type=template&id=54efd2b6&scoped=true&"
import script from "./weekPicker.vue?vue&type=script&lang=js&"
export * from "./weekPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54efd2b6",
  null
  
)

export default component.exports